"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PostContentWrapper = function (_a) {
    var _b;
    var tabIsShown = _a.tabIsShown, handleChangeTab = _a.handleChangeTab, handleClick = _a.handleClick, isScrolled = _a.isScrolled, isClicked = _a.isClicked, tabItemName = _a.tabItemName, tabContent = _a.tabContent, scrollTopPosition = _a.scrollTopPosition, smallestAbsoluteDistance = _a.smallestAbsoluteDistance, navHeight = _a.navHeight, checkSmallestAbsoluteDistance = _a.checkSmallestAbsoluteDistance;
    var itemRef = react_1.useRef(null);
    var interactionTimer = react_1.useRef(null);
    var _c = react_1.useState(null), topPosition = _c[0], setTopPosition = _c[1];
    react_1.useEffect(function () {
        return function () {
            interactionTimer.current && clearTimeout(interactionTimer.current);
        };
    }, []);
    react_1.useEffect(function () {
        var _a;
        itemRef.current && setTopPosition((_a = itemRef.current) === null || _a === void 0 ? void 0 : _a.offsetTop);
    }, [(_b = itemRef.current) === null || _b === void 0 ? void 0 : _b.offsetTop]);
    react_1.useEffect(function () {
        if (!isClicked && itemRef.current) {
            var absolutDistanceBetweenNavAndElement = Math.abs(scrollTopPosition - itemRef.current.offsetTop + navHeight);
            absolutDistanceBetweenNavAndElement <= smallestAbsoluteDistance &&
                handleChangeTab(tabItemName);
            tabIsShown === tabItemName &&
                checkSmallestAbsoluteDistance(absolutDistanceBetweenNavAndElement);
        }
    }, [scrollTopPosition]);
    react_1.useEffect(function () {
        if (tabIsShown === tabItemName) {
            if (isClicked) {
                topPosition && handleChangeTab(tabItemName, topPosition);
                interactionTimer.current = setTimeout(function () {
                    handleClick(false);
                }, 500);
            }
            else {
                isScrolled && handleChangeTab(tabItemName);
            }
        }
    }, [tabIsShown]);
    return react_1.default.createElement("div", { ref: itemRef }, tabContent);
};
exports.default = PostContentWrapper;
